var _circle, _circle2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoSubmenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8994,
    cy: 12.7279,
    r: 2,
    transform: "rotate(45 22.8994 12.7279)",
    fill: "#034781"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.10059,
    cy: 12.7279,
    r: 2,
    transform: "rotate(45 3.10059 12.7279)",
    fill: "#034781"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.51465,
    y: 11.3137,
    width: 16,
    height: 4,
    transform: "rotate(45 4.51465 11.3137)",
    fill: "#034781"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3137,
    y: 14.1421,
    width: 16,
    height: 4,
    transform: "rotate(135 24.3137 14.1421)",
    fill: "#034781"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSubmenu);
export default __webpack_public_path__ + "static/media/picto_submenu.75eae14e1174a416c4adadc4ac16fc57.svg";
export { ForwardRef as ReactComponent };